import styled from 'styled-components'

export const FormFlexContainer = styled.div`
  background: ${p => p.theme.webMktPalette.background.gray};
  padding-top: 40px;

  ${p => p.theme.breakpoints.down('sm')} {
    .formFlex--globalContainer {
      padding: 0;
    }
  }
`

export const FormFlexHeroContainer = styled.div`
  h1 {
    font-size: 44px;
  }

  p {
    font-size: 20px;
  }

  ${p => p.theme.breakpoints.down('sm')} {
    .heroInner {
      margin-top: 0;
      background: ${p => p.theme.webMktPalette.background.gray};
    }
    & > div {
      background-size: auto;
      background: ${p => p.theme.webMktPalette.background.gray};
    }
  }
`

export const FormFlexBodyContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;

  ${p => p.theme.breakpoints.down('sm')} {
    display: block;
  }
`

export const FormFlexFormContainer = styled.div`
  background: ${p => p.theme.webMktPalette.background.white};
  padding: 40px 15px;
  margin-bottom: 128px;
  width: 100%;
  ${p => p.theme.breakpoints.down('sm')} {
    background: ${p => p.theme.webMktPalette.background.white};
    box-shadow: 0px 16px 16px -8px rgba(0, 0, 0, 0.1);
    margin-bottom: 48px;
    padding: 24px 10px;

    width: 100%;
    box-sizing: border-box;
  }
`

export const FormFlexFormIntro = styled.div`
  h5.formFlex--FormIntro {
    padding-left: 12px;
    padding-bottom: 12px;
  }
`

export const FormFlexContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 129px;
  min-height: 700px;

  .ContentBlock--Grey > div {
    padding: unset;
    padding-bottom: 34px;
  }

  .ContentBlock__Body p {
    font-size: 18px;
  }

  .CTA {
    margin-bottom: 20px;
  }

  .CTA__Arrow-Container {
    color: ${p => p.theme.webMktPalette.text.primaryBlack};
  }

  .CTA:hover span {
    width: auto;
  }

  ${p => p.theme.breakpoints.down('sm')} {
    padding: 0 16px;
    min-height: auto;
    padding-bottom: 48px;
    background: ${p => p.theme.webMktPalette.background.gray};
    box-sizing: border-box;
  }
`
